
$(document).ready(function () {  

  // global variables

  
  const progressListItems = $("#progressbar li");
  let currentStep = 0;
  let otp_steps = 0;
  let api_token = "";
  let pincode_error_flag = false;
  let reg_error_flag = false;
  let reg_error_msg = "";
  // const base_url = "http://localhost:8080/book_a_service";                           // Dev Env
  const base_url = "https://uat-ecom-api.tvsmotor.net/book_a_service";                  // UAt Env
  // const base_url = "https://ecom-api.tvsmotor.com/book_a_service";                   // Prod Env
  
  let mobileNoError = false;
  
  var  token="";
  let slotAvailablity_data = [];
  
   let now = new Date();

    now.setTime(now.getTime() + (50 * 60 * 1000));
    
    let expires = "expires=" + now.toUTCString();

 // end


function isCookieSet(cookieName) {
    return document.cookie.split(';').some(cookie => {
        return cookie.trim().startsWith(cookieName + '=');
    });
}

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}


 async function setDataAfterReload(){    

if(isCookieSet("mobileNo")){
        console.log("value token", getCookie("mobileNo"));
        $("#mobile_no").val(getCookie("mobileNo"));

  console.log("isCookieSet(\"currentStep\")", isCookieSet("currentStep"));
      if(isCookieSet("currentStep")){
        console.log("value", getCookie("currentStep"));
            currentStep = getCookie("currentStep");
            
      } else {
          console.log("creating cookie");
          document.cookie = "currentStep=0; path=/; "+ expires +";";
        }
    
      if(isCookieSet("otpStep")){
            otp_steps = getCookie("otpStep");
           
      } else {
            document.cookie = "otpStep=0; path=/; "+ expires +";";
        }
  
    if(isCookieSet("jwt_token")){
        console.log("value token", getCookie("jwt_token"));
        token = getCookie("jwt_token");
      }
     if(isCookieSet("customerId")){
        console.log("value token", getCookie("customerId"));
       
       $("#customer_id").val(getCookie("customerId"));
      }
    
     if(isCookieSet("vehicleId")){
        console.log("value token", getCookie("vehicleId"));
        $("#vehicle_id").val(getCookie("vehicleId"));
      }
    if(isCookieSet("dealerId")){
        console.log("value dealerId", getCookie("dealerId"));
        $("#new_dealer_id").val(getCookie("dealerId"));
      }

      if(isCookieSet("pincode")){
        console.log("pincode", getCookie("pincode"));
        $("#pincode_search").val(getCookie("pincode"));
        pincode_error_flag = true;
        await getApiLAtLongAccessToken();
        await dealer_search();
        $("#"+getCookie("dealerId")).click();
      }


    showStep(currentStep);
    updateProgress();
      }  else {

  deleteCookie('customerId');
         deleteCookie('pincode');
        deleteCookie('jwt_token');
        deleteCookie('vehicleId');
        deleteCookie('dealerId');
        deleteCookie('mobileNo');
        deleteCookie('currentStep');
        deleteCookie('otpStep');
  
      }
      


     
   }

  async function seData(){
    $('#loaderr').css('display', 'flex');
     await setDataAfterReload();
    if(currentStep > 0){
      $('.next-step').html('Continue');
      
      await getCustomerVehicleInfo();
    if(currentStep >= 2)
      await Promise.all([
            fetchPreviousDealer(),
        ]);
    } 
    if(currentStep > 2){
      $(".next-step").show();
      let today_date = $("#booking_date").val();
        // let formated_date = formatDate(today_date);
      await fetchPreviousDealer();
      await Promise.all([
        setDealerDeatilsStep3(),
        setVehiclesDetailStep3()
      ]);
      setTimeout(function() {
        console.log("1 second has passed");
      }, 500);
      await fetchSlotAvailability(today_date);
    }

     var element = $('[data-id="'+ getCookie("dealerId") +'"]');
      console.log("element", element.html());
    if(element.attr('id') == "last_service_dealer"){
       $("#dealer_input").attr("checked",true);
      $("#last_service_dealer").click();
    }
    
    setTimeout(function() {
      $('#loaderr').css('display', 'none');
    }, 1000);
  }

  seData();

  function setCookie(name, value) {
    console.log("inside set cokkie");
    let cookieStr = `${name}=${encodeURIComponent(value)}`;
    const date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    
    cookieStr += `; ${expires}; path=/`;
    document.cookie = cookieStr;
  }

  


  function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');

    for(var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return false; 
  }

  

  function updateProgress() {
    progressListItems.each(function (index, item) {

      if (index == currentStep) {
        $(item).removeClass("complete").addClass("active");
      } else if (index < currentStep) {
        $(item).removeClass("active").addClass("complete");
      } else {
        $(item).removeClass("complete active");
      }
    });
  }

  function showStep(stepIndex) {
    $(".step-container .steps").each(function (index, step) {
      
      if (index == stepIndex) {
        console.log("inside here");
        $(step).show();
      } else {
        console.log("inside here else");
        
        $(step).hide();
      }
    });
    if(stepIndex != 0)
      $("#how_it_work").hide();
    else
      $("#how_it_work").show();
    
    if (stepIndex == 0 || stepIndex == 5 ||stepIndex == 4) {
      
      $("#progressbarMain").hide();
    } else {
      
      $("#progressbarMain").show();
    }
  }

  function setLoadingButtion(status) {

    var $button = $('#loader_button');
    if(status){
      $button.addClass('loading');
        $button.append('<div class="loader"></div>');

        setTimeout(function() {
            $button.removeClass('loading');
            $button.find('.loader').remove();
        }, 3000);
    } else{
      $button.removeClass('loading');
      $button.find('.loader').remove();
    }
        
    
  }
  
setDatesInCalender();
  async function nextStep(res = false) {
   
    let response = false;
    console.log("currentStep ", currentStep);
    console.log("otp_steps ", otp_steps);
    if (currentStep < progressListItems.length - 1) {
      if(currentStep == 0){
        if($('#tnc').is(':checked')){
          if(otp_steps == 0){
            checkMobileNo();
            if(!mobileNoError){
            response = await loginCustomer(); 
              
              if(response){
                otp_steps = 1;   
                $('#otp_popup').show();
                $('body').addClass('overflow-hidden');
              }
            } else {
              response = false;
            }
            return false;
          } else if(otp_steps == 1){
            
                response = await verifyOTP(); 
           
  
            console.log("verify otp response", response);
            if(response){
              otp_steps = 2;
            $('#otp_popup').hide();
              $('body').removeClass('overflow-hidden');
            }
          }
          $('#tncError').html('');
        } else{
          $('#tncError').html('Please Select I Agree to the Terms and Condition');
        }
         
          console.log('response', response);
      } else if(currentStep == 1){
         if($('#newRegistrationNumber').val() != ""){
           if(reg_error_flag){
             response = addaNewVehicle() ;
             return;
           } else {
              $('#reg_no_error').html(reg_error_msg);
            toastr.error("", reg_error_msg);
           }
           
         }else {
           if($('#vehicle_id').val() != ""){
             
             $('.next-step').prop('disabled', true);

              if(!res){
                
                let jobCardCheck = await checkJobCard();
               if(!jobCardCheck){
                   response = await fetchPreviousDealer();
                   $('.next-step').html('Continue');
                   $('.next-step').prop('disabled', false); 
                } else {
                  return;
                }
              } else {
                response = await fetchPreviousDealer();
                   $('.next-step').html('Continue');
                   $('.next-step').prop('disabled', false); 
              }               
           }
           else
            toastr.error("", "Please select vehicle");
             
         }
           
      } else if(currentStep == 3){

        let error = false;

        if($('#date_form_id').val() == "" ){
          error = true;
          $('#dateError').html('This field is required');
        } else 
          $('#dateError').html('');

        if($('#checkbox1').is(':checked')) {

          $('#job_card_checkmark_input').val(1);

          console.log($('#howManyKm').val());

          if($('#howManyKm').val() == "" || $('#howManyKm').val() == undefined){
            error = true;
            $('#howManyKmError').html('This field is required');
          } else 
              $('#howManyKmError').html("");

          if($('#customerVoice').val() == "" || $('#customerVoice').val() == undefined){          
            error = true;
            $('#customerVoiceError').html('This field is required');
          } else 
              $('#customerVoiceError').html("");
            
        } else {
          $('#job_card_checkmark_input').val(0);
        }
          
        if($('#time_form_id').val() == "" ){
          error = true;
          $('#timeError').html('This field is required');
        } else
          $('#timeError').html('');

        if( !$('#checkbox1').is(':checked') && !$('#checkbox2').is(':checked') ){
            error = true;
            $('#jobCardYesNo').html("Please select one");
        } else
            $('#jobCardYesNo').html("");
          
        if(error)
          return;
        
        response = await addJobCard();
 
        if(response)
           $('.next-step').html('Submit');
    
      } else if(currentStep == 2){

        let zxc = $('#new_dealer_id').val();
        console.log("zxc ->>", zxc);

        let today_date = $("#booking_date").val();
        // let formated_date = formatDate(today_date);

         await Promise.all([

            setVehiclesDetailStep3(),

            setDealerDeatilsStep3(),

         ]);

            setDatesInCalender();

            fetchSlotAvailability(today_date);

        
        if($('#new_dealer_id').val() == ""){
          toastr.error("", "Please select Dealer");
          return;
        }else{
          let zxc = $('#new_dealer_id').val();
        console.log("zxc ->>", zxc);
        }
        
      } else if(currentStep == 4){
        if($('#amc').is(':checked') || $('#rsa').is(':checked') || $('#vas').is(':checked'))
            response = await updateJobCard(); 
          // response = true;
      }
        
      console.log('currentStep', currentStep);
        
        console.log(response);

      if(response || currentStep == 2 || currentStep == 4){
        console.log("inside response if");
        if(otp_steps == 2){
        console.log("inside otp_steps if");
          
          currentStep++;
      if(currentStep < 4){
           setCookie("currentStep", currentStep);
          setCookie("otpStep", otp_steps);
      }
          
         
          
          
        }

          console.log("currentStep after 2 after", currentStep);
        

         showStep(currentStep);
      updateProgress();
      // getLatLong().then((latlong) => {
      //   getDealersLists(latlong.lat, latlong.lon);
      //   }).catch((error) => {
      //       console.error(error);
      //   });
        
      }
      
     
      // }
      
    }
  }

$(".slots").click(function(){
    var slot = $(this).find('.time_slot_js').attr('value');
    $("#slot_id").val(slot);

    const inputDate =  $("#booking_date").val();

  if(!$(this).hasClass("time-btn-slot-disable")){
         if(inputDate != "") {
        const inputTime = $("#slot_id").val();
        const year = 2024; 

        const dateParts = inputDate.split(' ');
        const monthShort = dateParts[0];
        const day = dateParts[1];
        const months = {
            "Jan": "01",
            "Feb": "02",
            "Mar": "03",
            "Apr": "04",
            "May": "05",
            "Jun": "06",
            "Jul": "07",
            "Aug": "08",
            "Sep": "09",
            "Oct": "10",
            "Nov": "11",
            "Dec": "12"
        };

        const month = months[monthShort];

        let hours = inputTime.substring(0, inputTime.length - 2);
        let minutes = inputTime.substring(inputTime.length - 2);
        hours = hours.padStart(2, '0'); 

        const formattedDate = `${day}-${month}-${year}`;
        const formattedTime = `${hours}:${minutes}`;
        const formattedDateTime = `${formattedDate} & ${formattedTime}`;

        $('#date_form_id').val(formattedDateTime);
        $('#date_time_modal').hide();
        $('body').removeClass('overflow-hidden');
    }
  }

   
});









$('#dates_container').on('click', '.date_slot', function() { 

    $(".slots").removeClass('time-btn-slot-disable')
    let date_selected = $(this).data("date");

    let selectedDateFormatted = formatDate(date_selected);

  console.log("selectedDateFormatted",selectedDateFormatted);

    $("#date_modal_selected").html(date_selected + " Available Slot");

    $('.date_slot').removeClass("active");
    $(this).toggleClass("active");
    $("#booking_date").val(selectedDateFormatted);

    fetchSlotAvailability(selectedDateFormatted); 
});

  function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return parseInt(hours + minutes);
}

  function formatDateasd(date) {
    const options = { month: 'short', day: 'numeric' }; 
    return date.toLocaleDateString('en-US', options);
}

async function fetchSlotAvailability(selectedDateFormatted) {
    try {
      let new_dealer_id = $("#new_dealer_id").val();


      
    if (!new_dealer_id || new_dealer_id.trim() === "") {
        if (isCookieSet('dealerId')) {
            var dealerIdFromCookie = getCookie('dealerId');
            if (dealerIdFromCookie) {
                $("#new_dealer_id").val(dealerIdFromCookie);
              new_dealer_id = dealerIdFromCookie;
            }
        }
    }
        const response = await $.ajax({
            url: base_url + '/getSlotAvailablity',
            method: 'GET',
            dataType: 'json',
            data: { new_dealer_id: new_dealer_id, booking_date: selectedDateFormatted }, 
            headers: {
                'Authorization': 'Bearer ' + token
            },
            crossDomain: true
        });

      // alert(selectedDateFormatted);

        if (response.status === 200) {

          let data = response.data;
          let count = 0;
          const currentTime = getCurrentTime();

          if (selectedDateFormatted == formatDateasd(new Date())) {

            $(".slots").each(function () {
                        let slotTime = parseInt($(this).find('.time_slot_js').attr('value'));
                        console.log("Slot Time:", slotTime);
                        if (slotTime < currentTime) {
                            $(this).addClass("time-btn-slot-disable");
                          count++;
                          $(this).prop("disabled", true);
                        }
                    });
                }

          
          data.forEach( (element) => {

            if (selectedDateFormatted == formatDateasd(new Date())) {
              if (parseInt(element.booking_slot_id) < currentTime) {
                $('.' + element.booking_slot_id).addClass("time-btn-slot-disable");
                // alert("in here");
                count++;
                $('.' + element.booking_slot_id).prop("disabled", true);
              }
            }
            
            $('.' + element.booking_slot_id).addClass("time-btn-slot-disable");
            $('.' + element.booking_slot_id).prop("disabled", true);
            
            count++;
          });
          return count;

        } 
    } catch (error) {
        console.log('Error fetching slot availability:', error);
    }
}

  
function formatDate(dateString) {
    const parts = dateString.split(', ');
    const dayMonth = parts[1].split(' ');
    return `${dayMonth[0]} ${dayMonth[1]}`;
}



  async function setDealerDeatilsStep3() {

      var dealerId = $("#new_dealer_id").val();

    if (!dealerId || dealerId.trim() === "") {
        if (isCookieSet('dealerId')) {
            var dealerIdFromCookie = getCookie('dealerId');
            if (dealerIdFromCookie) {
                $("#new_dealer_id").val(dealerIdFromCookie);
              dealerId = dealerIdFromCookie;
            }
        }
    }
      
      var radioInput = $('#' + dealerId);


      if (radioInput.length > 0) {

        var parentBox = radioInput.closest('.tvs_dealer_list');
        var dealer_name = parentBox.find('.dealer_name').text();
        var dealer_address = parentBox.find('.dealer_address').text();
        
        $("#dealer_name_step3").html(dealer_name);
        $("#dealer_address_step3").html(dealer_address);
        $("#dealer_name_thanku").html(dealer_name);
        $("#dealer_address_thanku").html(dealer_address);
        

      } else {
         var parentBox = radioInput.closest('.tvs_dealer_list');

        $("#dealer_name_thanku").html($("#previous_dealer_name").html());
        $("#dealer_address_thanku").html($("#previous_dealer_address").html());
        
        $("#dealer_name_step3").html($("#previous_dealer_name").html());
        $("#dealer_address_step3").html($("#previous_dealer_address").html());
      }

  }



  async function setDatesInCalender() {

      const numberOfDays = 30;
      const slotsAvailable = 13;
      const dateSlotsContainer = $('#dates_container');
    dateSlotsContainer.html("");
    
    

      for (let i = 0; i < numberOfDays; i++) {

          let date = new Date();

          date.setDate(date.getDate() + i);

          let options = { weekday: 'long', day: 'numeric', month: 'short' };

          let formattedDate = date.toLocaleDateString('en-US', options);

        if(i === 0){
          let asd = formattedDate.split(", ")[1];
          $("#booking_date").val(asd);
          // let date_selected=$(this).data("date");  

           let date_parts = formattedDate.split(" ");
           $("#date_modal_selected").html(date_parts[2] + " " + date_parts[1] + " Available Slot");
         }       

        let format_for_slot = formatDate(formattedDate);
        let no_of_slots = await fetchSlotAvailability(format_for_slot);
        no_of_slots = 21 - no_of_slots;
        console.log("no_of_slots", no_of_slots);
        // let no_of_slots = slots.length();

          let slotHtml = `
              <div class="date_slot ${i === 0 ? 'active' : ''}" data-date="${formattedDate}">
                  <h3 class="date">${formattedDate}</h3>
                  <p class="slot_availability">${no_of_slots} Slots Available</p>
              </div>
          `;
          dateSlotsContainer.append(slotHtml);
      }
  }



  async function setVehiclesDetailStep3() {

      var vehicleId = $("#vehicle_id").val();

    if (!vehicleId || vehicleId.trim() === "") {
        if (isCookieSet('vehicleId')) {
            var vehicleIdFromCookie = getCookie('vehicleId');
            if (vehicleIdFromCookie) {
                $("#vehicle_id").val(vehicleIdFromCookie);
              vehicleId = vehicleIdFromCookie;
            }
        }
    }
      var radioInput = $('#' + vehicleId);

      if (radioInput.length > 0) {

        var parentBox = radioInput.closest('.tvs_list_item_box');

        var regNo = parentBox.find('.reg_no').text();

        var bike_modal = parentBox.find('.bike_modal').text();

        var frameNo = parentBox.find('.frame_no').text();

        var bike_img = parentBox.find('.tvs_bike_img').html();

        console.log("bike_img - ", bike_img);
        

        $("#veh_regNo").html(regNo);

        $("#veh_img").html(bike_img);
        
        $("#customer_bike_image").html(bike_img);
        

        $("#veh_chaNo").html(frameNo);

        $('#bike_name_title').html(bike_modal);
      }
  }



  

  function prevStep() {
    if (currentStep > 0) {
      currentStep--;
      showStep(currentStep);
      updateProgress();
          setCookie("currentStep", currentStep);
      if(currentStep < 1){
        otp_steps = 0;
     
          setCookie("otpStep", otp_steps);
      }

      if(currentStep == 0){
      otp_steps = 0;
      $("#otp_div").hide();
      $('#otp').val("");
        $(".otp-input").val("");
        // $(".no_product").hide();
      $('.next-step').html('Send OTP');
         deleteCookie('customerId');
         deleteCookie('pincode');
        deleteCookie('jwt_token');
        deleteCookie('vehicleId');
        deleteCookie('dealerId');
        deleteCookie('mobileNo');
        deleteCookie('currentStep');
        deleteCookie('otpStep');
    }
      
    }
    
  }


  function getApiLAtLongAccessToken() {

    return new Promise((resolve, reject) => {

     $.ajax({
            url : 'https://api.latlong.in/oauth/token?grant_type=client_credentials&client_id=7ea3246c1e9101ef99d96a8c97295929ac43584e271245db5dba1b94b0386336&client_secret=ec1279b3e4c85a97e3c7fd7cbc9ff851c61babc919877917e092b8e9e9a4095a',
            method : "POST",
            dataType : "json",
            crossDomain: true,
            success : function (data){

                console.log(data);
                api_token = data.access_token;
              resolve(api_token);
            },
            error: function(error) {
                reject(error);
            }
    
  });
      });
            }

  $(".next-step").on("click", async () =>{
     $('#loaderr').css('display', 'block');
     $('.next-step').prop('disabled', true);
     await nextStep();
     $('#loaderr').css('display', 'none');
     $('.next-step').prop('disabled', false);
  });

  $("#reschedule_btn").on("click", async () =>{
     $('#res_jobcard_id_update').val($("#res_jobcard_id").html());
     $("#reschreschedule_popup").hide();
    
     $('#loaderr').css('display', 'block');
     $('.next-step').prop('disabled', true);
     await nextStep(true);
     $('#loaderr').css('display', 'none');
     $('.next-step').prop('disabled', false);
  });


 $('#qwe').on('click', '.next-step', async function() {
     $('#loaderr').css('display', 'block');
     $('.next-step').prop('disabled', true);
     await nextStep();
     $('#loaderr').css('display', 'none');
     $('.next-step').prop('disabled', false);
  });

  $('.tvsCustomDealers').on('click', '.next-step', async function() {
     $('#loaderr').css('display', 'block');
     $('.next-step').prop('disabled', true);
     await nextStep();
     $('#loaderr').css('display', 'none');
     $('.next-step').prop('disabled', false);
  });


  
  $(".previous-step").on("click", prevStep);

  const getDealersLists = (lat, long) => {
      const token_url = 'https://api.latlong.in/oauth/token?grant_type=client_credentials&client_id=7ea3246c1e9101ef99d96a8c97295929ac43584e271245db5dba1b94b0386336&client_secret=ec1279b3e4c85a97e3c7fd7cbc9ff851c61babc919877917e092b8e9e9a4095a'
      $.ajax({
          url : token_url,
          method : "POST",
          dataType : "json",
          crossDomain: true,
          success : function (data){
              console.log(data);
            api_token = data.access_token;
              $.ajax({
                  url : `https://api.latlong.in/v2/brands/514/stores_around.json?lat=${lat}&long=${long}&access_token=${data.access_token}`,
                  method : "GET",
                  dataType : "json",
                  crossDomain: true,
                  success : function (response){
                      const selectedDealers = $(".tvsCustomDealers");
                      $(selectedDealers).empty();
                      response.stores.forEach((dealer) => {

                        // $("#new_dealer_id").html(${dealer.id});
                        // console.log(dealer);
                          selectedDealers.append(`
                              <div class="tvs_pin_dealer_sec tvs_con_prvs_dealer dealers_select" id="${dealer.dealer_id}" style="margin-top: 4px">
                              <div class="tvs_dealer_item">
                                <div class="tvs_dealer_list">
                                  <div class="tvs_main_check_box dealers_select">
                                    <label class="tvs_checkbox">One
                                      <input type="radio" name="delaer_radio">
                                      <span class="tvs_checkmark"></span>
                                    </label>
                                  </div>
                                  <div class="tvs_dealer_info">
                                    <h4 class="dealer_name">${dealer.wp_name}</h4>
                                    <p class="dealer_address">
                                      ${dealer.address}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          `);
                      })
                  }
              })
          }
      })
  }



  // const getLatLong = () => {
  //     return new Promise((resolve, reject) => {
  //         if ("geolocation" in navigator) {
  //             navigator.geolocation.getCurrentPosition(function(position) {
  //                 var latitude = position.coords.latitude;
  //                 var longitude = position.coords.longitude;
  //                 // console.log("Latitude:", latitude, "Longitude:", longitude);
  //                 lat1 = latitude;
  //                 long1 = longitude;
  //                 getDealersLists();
  //                 resolve({ lat: latitude, lon: longitude });
  //             }, function(error) {
  //                 console.error("Error getting geolocation:", error.message);
  //                 reject(error);
  //             });
  //         } else {
  //             console.error("Geolocation is not supported by this browser.");
  //             reject(new Error("Geolocation is not supported"));
  //         }
  //     });
  // }


  // getLatLong().then((latlong) => {
  //     getDealersLists(latlong.lat, latlong.lon);
  // }).catch((error) => {
  //     console.error(error);
  // });

   $(".next-step").click(function(){
          $(window).scrollTop(0);
     $("#checkbox1").attr("checked",true);
   });


   $("#checkbox2").click(function(){
       $(".form_group.tvs_custom_input.job_card_form_group").hide();
      $('#create_job_card').val(0);
     
   })
    $("#checkbox1").click(function(){
       $(".form_group.tvs_custom_input.job_card_form_group").show();
      $('#create_job_card').val(1);
   })


// Anirudh 17/Apr
 


  let timerElement =  document.getElementById('timer');
  let otpInput = document.getElementById('otp');
  let resend = document.getElementById('resend');
  let resendButton = document.getElementById('resend');
  let timer;
  let timeLeft = 15;

    function startTimer() {
        timeLeft = 15; 
        otpInput.disabled = false; 
        otpInput.value = '';

      if (timer) {
        clearInterval(timer);
    }

        timer = setInterval(() => {
            if (timeLeft <= 0) {
                clearInterval(timer);
                // otpInput.disabled = true;
                $("#timer").html("<span class='didnt_rcv_otp'>Didn't Recive OTP ? </span><a id=\"resend\">Resend OTP</a>");
                // timerElement.innerText = '';
            } else {
               
                
                timerElement.innerHTML = `Resend OTP in: ${timeLeft} seconds`;
            }
            timeLeft -= 1;
        }, 1000);
    }

  $('#resend_div').on('click', '#resend', function() {
   if(timeLeft <= 0){
          clearInterval(timer);
          startTimer();
     loginCustomer();
     toastr.success("", "OTP Successfully sent");
     $("#otpError").html("");
        }
});

    // resendButton.addEventListener('click', () => {
     
        
    // });
    
  

  async function loginCustomer(asd = false) {
    let formData = $('#userinputData').serialize();
    
    setCookie("mobileNo", $("#mobile_no").val());    
    
    return $.ajax({
        url: base_url + `/loginCustomer`,
        method: "GET",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + "Orange@123"
        },
        crossDomain: true
    }).then(async function(response) {
       
        if(response.status == 200){
          let data = response.data;
          $('#customer_id').val(data.customer_id);
          setCookie("customerId", data.customer_id);
          token = response.token;
          setCookie("jwt_token", token);
          
          $("#otp_div").slideDown(400);
          $('.next-step').html('Continue');
          
          setCookie("customer_id", data.customer_id);
          setCookie("token", data.token);
          
          // await getCustomerVehicleInfo();
          if(asd){
          toastr.success("", "Vehicle added successfully");
            
          }else{
          // toastr.success("", "OTP Successfully sent");
            
          }
          $('#mobileError').html("");
          startTimer();
         
          return true;
        }
        else if(response.status == 400){
          toastr.error("", response.msg);
          $('#mobileError').html(response.msg);
          return false;
        }else if(response.status == 502){
          toastr.error("", response.msg);
          $('#mobileError').html(response.msg);
          return false;
        }
          
    }).catch(function(xhr) {
        console.log('Request Status: '+ xhr);
        return false;
    });
}

  function updateJobCard() {

    let formData = $('#userinputData').serialize();

    return $.ajax({
        url: base_url + `/updateJobCard`,
        method: "POST",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + token
        },
        crossDomain: true
    }).then(function(response) {
      if(response.status==200){
        // response=response.data;
        $("#cust_name").html("Dear " + response.data.name + ",");
        return true;
      } else if(response.status==500 || response.status==400 ){
        toastr.error("", "Something Went Wrong. Please Try Again");
      } else if(response.status==405)
        toastr.error("", response.msg);
        
    }).catch(function(xhr) {
        console.log('Request Status: ' + xhr);
        return false;
    });
    
  }

 function mergeOTP() {
    return new Promise((resolve) => {
        let mergedOtp = "";
        $('.otp-input').each(function() {
            mergedOtp += $(this).val();
        });
        $('#otp').val(mergedOtp);
        resolve();
    });
}

  async function verifyOTP() {
    
    await mergeOTP();
    
    let formData = $('#userinputData').serialize();

    if($("#otp").val() == ""){
      $("#otpError").html("Please Enter OTP");
    } else {

       return $.ajax({
        url: base_url + `/verifyOTP`,
        method: "GET",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + "Orange@123"
        },
        crossDomain: true
    }).then(async function(response) {


      console.log("getCookie(\"mobileNo\") ----", getCookie("mobileNo"));
      console.log("$(\"#mobileNo\").val() ----", $("#mobileNo").val());
       
        if(response.status == 200){
          $('.next-step').html('Continue');
          await getCustomerVehicleInfo();
          $('#mobileError').html("");
          $('#otpError').html("");
          return true;
        }
        else if(response.status == 400){
          toastr.error("", response.msg);
          $('#otpError').html(response.msg);
          return false;
        }else if(response.status == 502){
          toastr.error("", response.msg);
          $('#otpError').html(response.msg);
          return false;
        }
     
          
    }).catch(function(xhr) {
        console.log('Request Status: '+ xhr);
        return false;
    });
      
    }
  
    
   
}

  
// async function loginCustomer() {

//   let formData = $('#userinputData').serialize();

 
//      await $.ajax({
//               url : base_url + `/loginCustomer`,
//               method : "GET",
//               dataType : "json",
//               data : formData,
//               headers: {
//                   "Authorization": "Bearer " + "Orange@123"
//               },
//               crossDomain: true,
//               success : function (response){
//                  let data=response.data;
//                 $('#customer_id').val(data.customer_id);
//                 token=response.token;
//                 return true;
                
//               },
//                error: function(xhr){
//                       return false;                       
//                       console.log('Request Status: ' + xhr.status + ' Status Text: ' + xhr.statusText + ' ' + xhr.responseText);
//                   }
//       });
//     //      if(typeof response.data.customer_id !== 'undefined'){
//     //          response = true;
//     //       } else {
//     // response = false;
//     //   }

//   }
//prachi
function getCustomerVehicleInfo() {

  return new Promise((resolve) => {

  
    let formData = $('#userinputData').serialize();
    let check_vehicle_in_cookie = false;
   $('#qwe').html("");
    $.ajax({
        url: base_url + '/getCustomerVehicleInfo',
        method: "GET",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + token
        },
        crossDomain: true,
        success: function(response) {
          if(response.status == 200){
            let data = response.data;
            let innerdata = '';
          if(data.length > 0) {
            $(".no_product").hide();
            $("#select_vehicle_id").show();
            
            data.forEach((value, index) => {         
              
                innerdata += `<div class="tvs_list_item"> <div class="tvs_list_item_box">\
                      <div class="tvs_checkbox_main" data-vehicleId=${value.vehicle_id}>\
                        <label class="tvs_checkbox"\
                          >One\
                          <input type="radio" class="previous_models" name="vehicle_radio" id="${value.vehicle_id}" />\
                          <span class="tvs_checkmark modified"></span>\
                        </label>\
                      </div>\
                      <div class="tvs_bike_info">\
                        <h3 class="bike_modal">${value.model}</h3>\
                        <div class="tvs_bike_info_dec">\
                          <p>Registration Number</p>\
                          <h4 class="reg_no">${value.reg_no}</h4>\
                        </div>\
                        <div class="tvs_bike_info_dec">\
                          <p>Chassis Number</p>\
                          <h4 class="frame_no">${value.frame_no}</h4>\
                        </div>\
                      </div>\
                      <div class="tvs_bike_img">\
                      <img src="${value.image}" class="bike_img">
                      </div>\<div class="continue_btn_list"><button style="display:none;" type="button" class="next-step step2 vehicle_ctn_btn" disabled="false">Continue\
                     <span class="continue_arrow"><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_702_508)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9648 5.16039C11.0259 5.22135 11.0744 5.29377 11.1075 5.37349C11.1406 5.45322 11.1576 5.53869 11.1576 5.62501C11.1576 5.71133 11.1406 5.7968 11.1075 5.87653C11.0744 5.95626 11.0259 6.02868 10.9648 6.08964L3.55313 13.5L10.9648 20.9104C11.088 21.0336 11.1573 21.2007 11.1573 21.375C11.1573 21.5493 11.088 21.7164 10.9648 21.8396C10.8416 21.9629 10.6745 22.0321 10.5002 22.0321C10.3259 22.0321 10.1588 21.9629 10.0356 21.8396L2.16057 13.9646C2.09946 13.9037 2.05097 13.8313 2.01789 13.7515C1.9848 13.6718 1.96777 13.5863 1.96777 13.5C1.96777 13.4137 1.9848 13.3282 2.01789 13.2485C2.05097 13.1688 2.09946 13.0963 2.16057 13.0354L10.0356 5.16039C10.0965 5.09927 10.169 5.05079 10.2487 5.0177C10.3284 4.98462 10.4139 4.96759 10.5002 4.96759C10.5865 4.96759 10.672 4.98462 10.7517 5.0177C10.8314 5.05079 10.9039 5.09927 10.9648 5.16039Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.2148 5.16039C16.2759 5.22135 16.3244 5.29377 16.3575 5.37349C16.3906 5.45322 16.4076 5.53869 16.4076 5.62501C16.4076 5.71133 16.3906 5.7968 16.3575 5.87653C16.3244 5.95626 16.2759 6.02868 16.2148 6.08964L8.80313 13.5L16.2148 20.9104C16.2758 20.9714 16.3242 21.0438 16.3573 21.1236C16.3903 21.2033 16.4073 21.2887 16.4073 21.375C16.4073 21.4613 16.3903 21.5467 16.3573 21.6265C16.3242 21.7062 16.2758 21.7786 16.2148 21.8396C16.1538 21.9007 16.0814 21.9491 16.0016 21.9821C15.9219 22.0151 15.8365 22.0321 15.7502 22.0321C15.6639 22.0321 15.5785 22.0151 15.4987 21.9821C15.419 21.9491 15.3466 21.9007 15.2856 21.8396L7.41057 13.9646C7.34946 13.9037 7.30097 13.8313 7.26789 13.7515C7.2348 13.6718 7.21777 13.5863 7.21777 13.5C7.21777 13.4137 7.2348 13.3282 7.26789 13.2485C7.30097 13.1688 7.34946 13.0963 7.41057 13.0354L15.2856 5.16039C15.3465 5.09927 15.419 5.05079 15.4987 5.0177C15.5784 4.98462 15.6639 4.96759 15.7502 4.96759C15.8365 4.96759 15.922 4.98462 16.0017 5.0177C16.0814 5.05079 16.1539 5.09927 16.2148 5.16039Z" fill="#fff"/></g><defs><clipPath id="clip0_702_508"><rect width="21" height="21" fill="#fff"/></clipPath></defs></svg></span>\
                      </button></div>\
                    </div>\
                    </div>`;
//Shekhar
              if($("#vehicle_id").val() == value.vehicle_id){
                $("#"+value.vehicle_id).click();
                // $("#"+value.vehicle_id).toggleClass('modified');
               // console.log("inside thhissssssssssssssssssssssssssssssss");
              }
            });
            $('#qwe').html(innerdata);
            $('#customer_id').val(data[0].customer_id);

            if(isCookieSet("vehicleId")){
               document.getElementById(getCookie("vehicleId")).checked = true;        
                $('.next-step.step2').removeAttr('disabled');
            }
          } else {
            $('#qwe').closest('.tvs_book_step_two').addClass('no_listing');
            $(".no_product").show();
            $("#select_vehicle_id").hide();
            
          }
                          
        }
        }
    });
    resolve();
  });
}


  function addaNewVehicle() {
    let formData=$('#userinputData').serialize();
          $.ajax({
              url : base_url +  `/addNewVehicle`,
              method : "POST",
              dataType : "json",
              data : formData,
              headers: {
                  "Authorization": "Bearer " + token
              },
              crossDomain: true,
              success : function (response){
                if(response.status == 200){
                   toastr.success("", response.msg);

                let data = response.data;
                let innerdata = '';      
                $('#customer_id').val(data.customer_id);


                  innerdata += `<div class="tvs_list_item"> <div class="tvs_list_item_box">\
                      <div class="tvs_checkbox_main" data-vehicleId=${data.vehicle_id}>\
                        <label class="tvs_checkbox"\
                          >One\
                          <input type="radio" class="previous_models" name="vehicle_radio" id="${data.vehicle_id}" />\
                          <span class="tvs_checkmark modified"></span>\
                        </label>\
                      </div>\
                      <div class="tvs_bike_info">\
                        <h3 class="bike_modal">${data.model}</h3>\
                        <div class="tvs_bike_info_dec">\
                          <p>Registration Number</p>\
                          <h4 class="reg_no">${data.reg_no}</h4>\
                        </div>\
                        <div class="tvs_bike_info_dec">\
                          <p>Chassis Number</p>\
                          <h4 class="frame_no">${data.frame_no}</h4>\
                        </div>\
                      </div>\
                      <div class="tvs_bike_img">\
                      <img src="${data.image}" class="bike_img">
                      </div>\<div class="continue_btn_list"><button style="display:none;" type="button" class="next-step step2 vehicle_ctn_btn" disabled="false">Continue\
                     <span class="continue_arrow"><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_702_508)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9648 5.16039C11.0259 5.22135 11.0744 5.29377 11.1075 5.37349C11.1406 5.45322 11.1576 5.53869 11.1576 5.62501C11.1576 5.71133 11.1406 5.7968 11.1075 5.87653C11.0744 5.95626 11.0259 6.02868 10.9648 6.08964L3.55313 13.5L10.9648 20.9104C11.088 21.0336 11.1573 21.2007 11.1573 21.375C11.1573 21.5493 11.088 21.7164 10.9648 21.8396C10.8416 21.9629 10.6745 22.0321 10.5002 22.0321C10.3259 22.0321 10.1588 21.9629 10.0356 21.8396L2.16057 13.9646C2.09946 13.9037 2.05097 13.8313 2.01789 13.7515C1.9848 13.6718 1.96777 13.5863 1.96777 13.5C1.96777 13.4137 1.9848 13.3282 2.01789 13.2485C2.05097 13.1688 2.09946 13.0963 2.16057 13.0354L10.0356 5.16039C10.0965 5.09927 10.169 5.05079 10.2487 5.0177C10.3284 4.98462 10.4139 4.96759 10.5002 4.96759C10.5865 4.96759 10.672 4.98462 10.7517 5.0177C10.8314 5.05079 10.9039 5.09927 10.9648 5.16039Z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.2148 5.16039C16.2759 5.22135 16.3244 5.29377 16.3575 5.37349C16.3906 5.45322 16.4076 5.53869 16.4076 5.62501C16.4076 5.71133 16.3906 5.7968 16.3575 5.87653C16.3244 5.95626 16.2759 6.02868 16.2148 6.08964L8.80313 13.5L16.2148 20.9104C16.2758 20.9714 16.3242 21.0438 16.3573 21.1236C16.3903 21.2033 16.4073 21.2887 16.4073 21.375C16.4073 21.4613 16.3903 21.5467 16.3573 21.6265C16.3242 21.7062 16.2758 21.7786 16.2148 21.8396C16.1538 21.9007 16.0814 21.9491 16.0016 21.9821C15.9219 22.0151 15.8365 22.0321 15.7502 22.0321C15.6639 22.0321 15.5785 22.0151 15.4987 21.9821C15.419 21.9491 15.3466 21.9007 15.2856 21.8396L7.41057 13.9646C7.34946 13.9037 7.30097 13.8313 7.26789 13.7515C7.2348 13.6718 7.21777 13.5863 7.21777 13.5C7.21777 13.4137 7.2348 13.3282 7.26789 13.2485C7.30097 13.1688 7.34946 13.0963 7.41057 13.0354L15.2856 5.16039C15.3465 5.09927 15.419 5.05079 15.4987 5.0177C15.5784 4.98462 15.6639 4.96759 15.7502 4.96759C15.8365 4.96759 15.922 4.98462 16.0017 5.0177C16.0814 5.05079 16.1539 5.09927 16.2148 5.16039Z" fill="#fff"/></g><defs><clipPath id="clip0_702_508"><rect width="21" height="21" fill="#fff"/></clipPath></defs></svg></span>\
                      </button></div>\
                    </div>\
                    </div>`;

                  $('#qwe').append(innerdata);

                  $("#"+data.vehicle_id).click();
                  $('.vehicle_ctn_btn').click();
                  
                if($("#vehicle_id").val() == data.vehicle_id){
                  $("#"+data.vehicle_id).click();
                }
      
                
                $("#newRegistrationNumber").val('');
                   $(".no_product").hide();
            $("#select_vehicle_id").show();
                  
                } else if(response.status == 502){
                   toastr.error("", response.msg);
                } else if(response.status == 500){
                   toastr.error("", "Something went wrong");
                } else if(response.status == 404)  
                   toastr.error("", "Vehicle Not Found");
              } 
          });
  }


  
// function addaNewVehicle() {
//     let formData=$('#userinputData').serialize();
//           $.ajax({
//               url : base_url +  `/mapNewVehicle`,
//               method : "POST",
//               dataType : "json",
//               data : formData,
//               headers: {
//                   "Authorization": "Bearer " + token
//               },
//               crossDomain: true,
//               success : function (response){
//                 if(response.status == 200){
//                    toastr.success("", response.msg);
//                    var inputField = document.getElementById('newRegistrationNumber');
//                    inputField.value = '';
               
//                    // getCustomerVehicleInfo();
//                 } else if(response.status == 502){
//                    toastr.error("", response.msg);
//                 } else if(response.status == 500){
//                    toastr.error("", "Something went wrong");
//                 }         
//               } 
//           });
//   }

  async function checkJobCard() {

    let formData=$('#userinputData').serialize();
    
    return $.ajax({
        url: base_url + `/checkJobCard`,
        method: "GET",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + token
        },
        crossDomain: true
    }).then(function(response) {
        let data = response.data;
        let status = response.status;
        let jobCard_exist = response.jobCardCheck;
        if(status == 200){
            if(jobCard_exist){
              
                $("#res_jobcard_id").html(data.dms_job_id);
                $("#res_customer_voice").html(data.job_card_customer_voice);
                $("#res_dealer_name").html(data.dealer);
                $("#res_delaer_address").html(data.dealer_address);
                $("#res_time_slot_proper").html(data.date);
                $("#res_time_slot").html(data.time);
                $("#res_dealer_email").html(data.dealer_email);
                $("#res_dealer_number").html(data.delaer_contact_no);
                $("#res_customer_voice").html(data.note);
              
                $("#reschreschedule_popup").show();
              return true;
            } else 
              return jobCard_exist;
        }
        
        return true;
    }).catch(function(xhr) {
        console.log('Request Status: ' + xhr);
        return false;
    });
    
  }


  async function fetchPreviousDealer() {

    getApiLAtLongAccessToken();
    let formData=$('#userinputData').serialize();
    
    return $.ajax({
        url: base_url + `/lastServiceRecord`,
        method: "GET",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + token
        },
        crossDomain: true
    }).then(function(response) {
        let data = response.data;
        if(data === ""){
          // $('#last_service_dealer').html("<strong class=\"previous_dealer_error\">No previous service record found !</strong>");
  
          $(".prv_dealer_btn").hide();
           $('#last_service_dealer_no_data').show();
          $('#last_service_dealer_no_data').html("<strong class=\"previous_dealer_error\">No previous service record found !</strong>");
          $('#last_service_dealer').hide();
          $("#last_service_km_main_span").hide();
          $('#orId').hide();
        }else{
          $('#last_service_dealer').show();
           $('#last_service_dealer_no_data').hide();
          $('#last_service_dealer').attr('data-id', data.dealer.id);
          // $('#last_service_dealer').attr('id', data.dealer.id);
 
          $(".prv_dealer_btn").hide();
          $('#last_service_km').html(response.km);
          
          $("#previous_dealer_name").html(data.dealer.name);
          $("#previous_dealer_address").html(data.dealer.address);
          // if(isCookieSet("vehicleId")){
          //   $("#"+ data.dealer.id+ " input").prop('checked', true);
          //    document.getElementById(getCookie("dealerId")).checked = true;        
          //     // $('.next-step.step2').removeAttr('disabled');
          // }
        } 
        if(response.status == 400)
            toastr.error("", "Something Went Wrong. Please Try Again");        
        
        return true;
    }).catch(function(xhr) {
        console.log('Request Status: ' + xhr);
        return false;
    });
    
  }


  

    $(".previous_models").click(function(){
         $("#newRegistrationNumber").val("");
    });
    
    // $("#newRegistrationNumber").click(function(){
    //      // $("#newRegistrationNumber").val("");
    // });


  function addJobCard() {
 
    let formData = $('#userinputData').serialize();


    return $.ajax({
        url: base_url + `/addJobCard`,
        method: "POST",
        dataType: "json",
        data: formData,
        headers: {
            "Authorization": "Bearer " + token
        },
        crossDomain: true
    }).then(function(response) {
      if(response.status==200){
        response=response.data,
    

        $('#thank_you_msg').html(response.thank_you_msg);
        $('#jobcard_time').html(response.time);
        $('#jobbcard_date').html(response.date);
        $('#jobbcard_dealer').html(response.dealer);
        $('#jobbcard_dealerAddress').html(response.dealer_address);
        $('#jobbcard_dealerEMAIL').html(response.dealer_email);
        $('#jobbcard_dealerContactno').html(response.delaer_contact_no);
        $('#jobbcard_srNo').html(response.dms_job_id);
        $('#job_card_id').val(response.dms_job_id);
        $("#job_card_customer_voice").html(response.job_card_customer_voice);
        $("#time_slot_in_format").html(response.time);

        deleteCookie('customerId');
         deleteCookie('pincode');
        deleteCookie('jwt_token');
        deleteCookie('vehicleId');
        deleteCookie('dealerId');
        deleteCookie('mobileNo');
        deleteCookie('currentStep');
        deleteCookie('otpStep');
        
        return true;
      } else if(response.status==500 || response.status==400 ){
        toastr.error("", "Something Went Wrong. Please Try Again");
      } else if(response.status==405)
        toastr.error("", response.msg);
        
      
    });


  }



  $("#pincode_button").on("click", dealer_search );


  function dealer_search() 

    {
let pincode = $('#pincode_search').val();

      if($("#new_dealer_id").val() != ""){
        $("#"+ $("#new_dealer_id").val()).attr("checked",true);
        $("#new_dealer_id").val("");
      }
      
      console.log(pincode);

    if(pincode !== ""){
      
    } else{
        $('#pincodeError').html("Please enter pincode");
      
    }

    if(pincode_error_flag) {     
    

    return $.ajax({
        url: "https://api.latlong.in/v2/location_details.json?location=" + pincode + "&access_token="+ api_token,
        method: "GET",
        dataType: "json",
        crossDomain: true
    }).then(function(response) {

        $('#pincodeError').html("");
      

      return $.ajax({
        url: "https://api.latlong.in/v2/brands/514/find.json?query="+ response.pincode + "&access_token="+ api_token,
        method: "GET",
        dataType: "json",
        crossDomain: true
    }).then(function(qwe) {

        $('#pincodeError').html("");
        

        const selectedDealers = $(".tvsCustomDealers");
                        $(selectedDealers).empty();
                        qwe.stores.forEach((dealer) => {

                          // $("#new_dealer_id").html(${dealer.id});
                          // console.log(dealer);


                          var point = dealer.geofeature.geoproperty;

   
            var coordinates = point.match(/POINT \(([^)]+)\)/)[1].split(" ");
            var longitude = coordinates[0];
            var latitude = coordinates[1];

            var googleMapsLink = "https://www.google.com/maps/dir/?api=1&destination=" + latitude + "," + longitude;

                          let phone = dealer.phone_no;
                          console.log("dealer.phone_no", dealer.phone_no);
                          let zxc = phone.split("/")
                          console.log("zxc", zxc);
                          let dealer_phone = "";
                          if(zxc.length > 1){
                            dealer_phone = zxc[0] + "<br>" + zxc[1];
                          } else {
                            dealer_phone = zxc;
                          }
                          
                          $("#dealer_banner").hide();
                            selectedDealers.append(`
                                <div class="tvs_pin_dealer_sec tvs_con_prvs_dealer dealers_select" style="margin-top: 4px" data-id="${dealer.dealer_id}">
                                <div class="tvs_dealer_item">
                                  <div class="tvs_dealer_list">
                                    <div class="tvs_main_check_box dealers_select">
                                      <label class="tvs_checkbox">One
                                        <input type="radio" name="delaer_radio" id="${dealer.dealer_id}">
                                        <span class="tvs_checkmark"></span>
                                      </label>
                                    </div>
                                    <div class="tvs_dealer_info">
                                      <div class="dealer_image">
                                        <img src="https://cdn.shopify.com/s/files/1/0668/0304/0515/files/om-tvs_1.png?v=1720520630"/>
                                      </div>
                                     <div class="dealer_info_p">
                                        <h4 class="dealer_name">${dealer.wp_name}</h4>
                                    <p class="dealer_address">
                                      ${dealer.address}
                                    </p>
                                      
                                     </div>
                                    <div class="dealer_contact_info">
                                      <p class="contact_no">
                                        <img src="https://cdn.shopify.com/s/files/1/0668/0304/0515/files/Vector_3_d748cf66-16c5-4c5e-a3da-a69a77ebe8b1.png?v=1720520955"/>
                                        <span style="z-index:9;">${dealer_phone}</span>
                                      </p>
                                      <a href="${googleMapsLink}" style="z-index:9;" target="_blank">
                                        <img src="https://cdn.shopify.com/s/files/1/0668/0304/0515/files/Vector_4_ae30da42-b5c5-45e5-b830-272652df53a2.png?v=1720521389" />
                                      </a>
                                    </div>
                                    <div class="previous_dealer_continue js"><button type="button" style="display:none;" class="next-step step2 dealer_ctn_btn">Continue
                                    </button></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            `);

                          if (window.innerWidth <= 768) {
                             $('html, body').animate({ scrollTop: 0 }, 'slow');
                          }
                        });


       
    }).catch(function(xhr) {
        $('#pincodeError').html("Invalid pincode");
        console.log('Request Status: '+ xhr);
        return false;
    }); 
        return true;
    }).catch(function(xhr) {
        $('#pincodeError').html("Invalid pincode");
        console.log('Request Status: '+ xhr);
        return false;
    });

    
    }else{
      $('.tvsCustomDealers').html("");
      $("#dealer_banner").show();
    } 


    

    
  }
    
  





// book a service code 

    var inputField = document.getElementById('newRegistrationNumber');
  var continueButton = document.getElementsByClassName('step2');
    $('#qwe').on('click', '.tvs_checkbox', function() {

    
        $('.next-step.step2').removeAttr('disabled');
         inputField.value="";
      
      
    });

$('#qwe').on('click', '.tvs_checkbox_main', function() { // Anirudh

  let vehicle_id_selected=$(this).data("vehicleid");  
  setCookie("vehicleId", vehicle_id_selected);
  $('#vehicle_id').val(vehicle_id_selected);
  $("#reg_no_error").html("");

  $(".vehicle_ctn_btn").hide();

  var radioInput = $(this);

  if (radioInput.length > 0) {
    var parentBox = radioInput.closest('.tvs_list_item_box');
    var dealer_name = parentBox.find('.next-step');

    dealer_name.show();
  }
  
});
 
$('.tvsCustomDealers').on('click', '.dealers_select', function() {

  let dealer_id_selected=$(this).data("id");  
  setCookie("dealerId", dealer_id_selected);
  setCookie("pincode", $("#pincode_search").val());
  
  $('#new_dealer_id').val(dealer_id_selected);


  $(".dealer_ctn_btn").hide();


    var dealer_name = $(this).find('.next-step');

    dealer_name.show();

  
  
});



 $('#qwe').on('dblclick', '.tvs_checkbox', function() {
    $(this).prop('checked', false);
 });

$("#last_service_dealer").click(function(){
  
  let newDealer_id_selected=$(this).data("id");
  setCookie("dealerId", newDealer_id_selected);
  setCookie("pincode", $("#pincode_search").val());



  $(".dealer_ctn_btn").hide();


    var dealer_name = $(this).find('.next-step');

    dealer_name.show();

  
  $('#new_dealer_id').val(newDealer_id_selected);
});


$('#tvsCustomNewDealer').on('click', '.tvs_checkbox_main', function() {
  
  let newDealer_id_selected=$(this).data("id");
  setCookie("dealerId", newDealer_id_selected);
  setCookie("pincode", $("#pincode_search").val());
  
  $('#new_dealer_id').val(newDealer_id_selected);
  
});
                            


inputField.addEventListener('input', function() {
    if (inputField.value.trim() !== '') {

      document.getElementById($("#vehicle_id").val()).checked = false

      
      $("#vehicle_id").val("");
        $('.next-step.step2').removeAttr('disabled');
     // document.querySelectorAll('input[type="radio"]').removeAttribute("checked");
    $('input[name=radio]').prop('checked',false);
      
    }
        
     else {
        $('.next-step.step2').attr("disabled");

     }

     $("#dealer_input").attr("checked",false);
  

  
});

    $('.tvs_dealer_list input[name="radio"]').click(function() {
        if ($(this).is(':checked')) {
            // Deselect any radio button in the .tvsCustomDealers section
            $('.tvsCustomDealers input[name="dealer"]').prop('checked', false);
        }
    });

$(document).on('click', '.tvsCustomDealers input[name="dealer"]', function() {
        if ($(this).is(':checked')) {
          
            $('.tvs_dealer_list input[name="radio"]').prop('checked', false);
        }
    });

 document.getElementById('mobile_no').addEventListener('input', checkMobileNo);

$('.otp-input').on('input', function() {

        var currentValue = $(this).val();

        var filteredValue = currentValue.replace(/\D/g, '');

        $(this).val(filteredValue);
    });

    $('.otp-input').on('keypress', function(event) {
        var keyCode = event.which ? event.which : event.keyCode;
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault();
        }
    });

  function checkMobileNo(){
      var mobileNo = $("#mobile_no").val();
      var mobileError = document.getElementById('mobileError');
      var regex = /^\d{10}$/;

     mobileNo = mobileNo.replace(/\D/g, '');

    if (mobileNo.length > 10) {
        mobileNo = mobileNo.substring(0, 10);
    }

    
    $("#mobile_no").val(mobileNo);

 
    $("#mobile_no").val(mobileNo);
    
      if (regex.test(mobileNo)) {
        
        mobileError.textContent = '';
       mobileNoError = false;
        
      } else {
        
       mobileNoError = true;
        
        mobileError.textContent = 'Enter a valid Mobile Number';
      }
  }

// document.addEventListener("DOMContentLoaded", function() {
    var dateInput = document.getElementById("date_form_id");
    var timeSelect = document.getElementById("time_form_id");


  

    dateInput.addEventListener("change", function() {
        var selectedDate = new Date(this.value);
        var today = new Date();
        var selectedTime = today.getHours() * 100 + today.getMinutes();

 

        if (selectedDate <= today) {
          console.log("in here 1 if");
            timeSelect.disabled = true;
        } else {
          console.log("in here 1 else");
          
            if (selectedDate.getDate() === today.getDate() && selectedDate.getMonth() === today.getMonth() && selectedDate.getFullYear() === today.getFullYear()) {
          console.log("in here 1 else if");
              
                disablePastTimes(selectedTime);
            } else {
          console.log("in here 1 else else");
              
                timeSelect.disabled = false;
            }
        }
    });


    function disablePastTimes(selectedTime) {


      
        var options = timeSelect.getElementsByTagName("option");
        for (var i = 0; i < options.length; i++) {
            var optionTime = parseInt(options[i].value);
            if (optionTime < selectedTime) {
                options[i].disabled = true;
            } else {
                options[i].disabled = false;
            }
        }
        timeSelect.disabled = false;
    }
// });
   document.getElementById('pincode_search').addEventListener('input', function() {
    const pincodeInput = document.getElementById('pincode_search');
    const pincodeError = document.getElementById('pincodeError');
    const pincode = pincodeInput.value;
    const regex = /^\d{6}$/;
     

     $(".tvsCustomDealers").html("");
     $("#dealer_banner").show();
     document.getElementById("dealer_input").checked = false;
     $(".prv_dealer_btn").hide();
     $("#dealer_input").attr("checked",false);
     $("#new_dealer_id").val("");

    if (regex.test(pincode)) {
      pincodeError.textContent = '';
      pincode_error_flag = true;
      
    } else {
      pincodeError.textContent = 'Please enter a valid  pincode.';
      pincode_error_flag = false;
    }
  });









$('#newRegistrationNumber').on('input', function() {

  let reg_no = $("#newRegistrationNumber").val();

  if(reg_no.length < 11){
    const two_letter_regex = /^[A-Za-z]{2}\d{2}[A-Za-z]{2}\d{4}$/;  
    const one_letter_regex = /^[A-Za-z]{2}\d{2}[A-Za-z]\d{4}$/;
    
    if (two_letter_regex.test(reg_no) || one_letter_regex.test(reg_no)) {
      $('#reg_no_error').html("")
      reg_error_flag = true;
      reg_error_msg = "";
    } else {
      reg_error_msg = "Enter a valid Registration No";
      $('#reg_no_error').html(reg_error_msg);
      reg_error_flag = false;
    } 
  } else {
    if(reg_no.length == 17){
      $('#reg_no_error').html("");
      reg_error_flag = true;
      reg_error_msg = "";
    } else{
      reg_error_msg = "Enter a valid Chassis Number";
      
      $('#reg_no_error').html(reg_error_msg);
      reg_error_flag = false;
    }
  }

  
  
});

  $('.otp_close').on('click', function() {
      otp_steps = 0;
      $('.next-step').html("Send OTP");
      $('#otp_popup').hide();
    $('body').removeClass('overflow-hidden');
    }); 

   $('.focus-inset').on('click', function() {

    deleteCookie('customerId');
         deleteCookie('pincode');
        deleteCookie('jwt_token');
        deleteCookie('vehicleId');
        deleteCookie('dealerId');
        deleteCookie('mobileNo');
        deleteCookie('currentStep');
        deleteCookie('otpStep');
    });
  
  $(".apply_btn").on('click', function() {


      let values = [];
      $(".tagify__tag").each(function() {
          values.push($(this).attr("value"));
      });
      let result = values.join(", ");

    $("#customerVoice").val(result);
    $('#complaint_popup').hide();
        $('body').removeClass('overflow-hidden');
      
  });
  
  $(".reasons").on('click', function() {

    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      let complaints = $("#complaints").val();
      let selected_complaints = $(this).text();

      if(complaints == ""){
        complaints = selected_complaints;
      } else {
        complaints = complaints + ", " + selected_complaints;
      }
      
      $("#complaints").val(complaints);
    } else {
      let selected_complaints = $(this).text();
      let complaints = $("#complaints").val();
      arr = complaints.split(", ");
      console.log(arr);
      for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i] == selected_complaints) {
              arr.splice(i, 1);
          }
      }
     complaints = arr.join(", ");
      $("#complaints").val(complaints);
      
    }
    
      
  });


const today = new Date();
today.setDate(today.getDate() + 1); 
const tommorow = today.toISOString().split('T')[0];
            document.getElementById('date_form_id').setAttribute('min', tommorow);


  });

  document.addEventListener('DOMContentLoaded', function() {
    const radioButtons = document.querySelectorAll('.previous_models');
    const inputField = document.getElementById('newRegistrationNumber');
    const continueButton = document.querySelector('.next-step.step2');

    function validateForm() {
        const isRadioSelected = Array.from(radioButtons).some(radio => radio.checked);
        const isInputFieldNotEmpty = inputField.value.trim() !== '';

        if (isRadioSelected || isInputFieldNotEmpty) {
            continueButton.removeAttribute('disabled');
        } else {
            continueButton.setAttribute('disabled', 'true');
        }
    }

    radioButtons.forEach(radio => {
        radio.addEventListener('change', function() {
            validateForm();
            if (inputField.value.trim() !== '') {
                radio.checked = false;
            }
        });
    });

    inputField.addEventListener('input', function() {
        validateForm();

        if (inputField.value.trim() !== '') {
            radioButtons.forEach(radio => {
                radio.checked = false;
            });
        }
    });

    validateForm();
});








